import { createFileRoute, useRouteContext } from "@tanstack/react-router";
import AppCard from "@components/AppCard.tsx";
import LaboratoryDocumentsSection from "@components/laboratory/documents/LaboratoryDocumentsSection.tsx";
import { useGetLaboratoryUserQuery } from "@/api/LaboratoryUsersApi";
import { requireRole } from "@/auth/requireRole.ts";
import { ROLE_USER } from "@/constants";
import { CircularProgress } from "@mui/material";

export const Route = createFileRoute("/_dashboard/certificats/")({
  beforeLoad: (args) => {
    requireRole([ROLE_USER])(args);
  },
  component: RouteComponent,
});

function RouteComponent() {
  const context = useRouteContext({ strict: false });
  const userUuid = context.session!.user!.uuid;
  const { data: laboratoryUser, isLoading } = useGetLaboratoryUserQuery(userUuid);
  const laboratoryUuid = laboratoryUser?.laboratory?.uuid;

  if (isLoading) return <CircularProgress />;

  return (
    <AppCard title="Certificats">
      {laboratoryUuid && <LaboratoryDocumentsSection laboratoryUuid={laboratoryUuid} />}
    </AppCard>
  );
}
